import * as AddPeopleActions from '../actions/addPeopleActions';
import {addNewPeopleTransformation, cancelRequestsPeopleTransformation} from "../../utils/addPeopleTransformation";

const defaultState = {
    requests: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case AddPeopleActions.ACTION_GET_REQUESTS:
            return {
                ...state,
                requests: action.payload
            };
        case AddPeopleActions.ACTION_ADD_NEW_PEOPLE:
            return {
                ...state,
                requests: addNewPeopleTransformation(state.requests, action.payload)
            };
        case AddPeopleActions.ACTION_CANCEL_REQUESTS_PEOPLE:
            return {
                ...state,
                requests: cancelRequestsPeopleTransformation(state.requests, action.payload)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/addPeopleReducer.js